import {useState, useEffect} from 'react'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import SharedModal from '../../../sharedComponent/SharedModal'
import TextField from '../../../sharedComponent/TextField/TextField'
import {Spinner} from 'react-bootstrap'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {
  CREATE_LIVE_AGENT,
  GET_ALL_LIVE_AGENTS,
  GET_ALL_VENDORS,
  GET_LIVE_AGENT_BY_ID,
  UPDATE_LIVE_AGENT,
} from '../../../../utils/GraphQLAPI'
import {alert} from '../../../../utils/helper'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import Dropdown from '../../../sharedComponent/Dropdown/Dropdown'
import {LATEXTS, LISTCONFIGS} from '../../../../utils/LiveAgent/LiveAgentsUtils'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {dropdownMenuItemsType} from '../../../sharedComponent/SearchList/SearchList.types'

const defaultLiveAgentProps = {
  liveagentFirstName: '',
  liveagentLastName: '',
  liveagentEmail: '',
  liveagentVendor: '',
  id: '',
}
const validationSchema = {
  liveagentFirstName: Yup.string().required('First name is required'),
  liveagentEmail: Yup.string()
    .required('Email ID is required')
    .trim()
    .email('Enter a valid email id'),
  liveagentVendor: Yup.string().required('Vendor is required'),
}
const LiveAgents = () => {
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    perPage: 10,
    searchText: '',
  })

  const [activeStatus, setActiveStatus] = useState(true)
  const [modalConfig, setModalConfig] = useState({
    show: false,
    mode: 'CREATE',
  })
  const [vendors, setVendors] = useState<any>([])
  const handleModalClose = () => {
    setModalConfig({
      ...modalConfig,
      show: false,
    })
    formik.setTouched({})
    formik.setValues(defaultLiveAgentProps)
  }
  const formik: any = useFormik({
    initialValues: defaultLiveAgentProps,
    validationSchema: Yup.object().shape(validationSchema),
    enableReinitialize: true,
    onSubmit: (values) => {
      if (modalConfig.mode === 'CREATE') {
        createLiveAgent({
          variables: {
            createLiveAgentInputs: {
              liveAgentStatus: activeStatus,
              liveAgentEmail: values.liveagentEmail.toLowerCase(),
              liveAgentFirstName: values.liveagentFirstName,
              liveAgentLastName: values.liveagentLastName,
              vendorId: vendors.filter((vendor: any) => vendor.value === values.liveagentVendor)[0]
                ?.id,
            },
          },
        })
      } else {
        updateLiveagent({
          variables: {
            updateLiveAgentInputs: {
              id: formik.values.id,
              liveAgentFirstName: values.liveagentFirstName,
              liveAgentLastName: values.liveagentLastName,
              liveAgentStatus: activeStatus,
            },
          },
        })
      }
    },
  })

  //effect
  useEffect(() => {
    getAllLiveagents()
  }, [])

  //Queries
  const [createLiveAgent] = useMutation(CREATE_LIVE_AGENT, {
    onCompleted: () => {
      alert(LATEXTS.addModalSuccess, 'success')
      handleModalClose()
      getAllLiveagents()
    },
    onError: (err) => {
      if (err.message.includes('duplicate')) {
        alert(LATEXTS.duplicateEmailMsg, 'error')
      } else {
        alert(err.message, 'error')
      }
    },
  })
  const [updateLiveagent] = useMutation(UPDATE_LIVE_AGENT, {
    onCompleted: (data) => {
      alert(LATEXTS.editModalSuccess, 'success')
      getAllLiveagents()
      handleModalClose()
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  const [getAllLiveagents, {loading: listLoading, data: liveagents}] = useLazyQuery(
    GET_ALL_LIVE_AGENTS,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      variables: {
        getAllLiveAgentsInput: filterOptions,
      },
    }
  )

  const [getLiveagentbyId, {loading: getLoading}] = useLazyQuery(GET_LIVE_AGENT_BY_ID, {
    onCompleted: ({getLiveAgentById}) => {
      setActiveStatus(getLiveAgentById?.liveAgentStatus)
      formik.setValues({
        liveagentFirstName: getLiveAgentById?.liveAgentFirstName,
        liveagentLastName: getLiveAgentById?.liveAgentLastName,
        liveagentEmail: getLiveAgentById?.liveAgentEmail,
        id: getLiveAgentById?.id,
        liveagentVendor: vendors.filter(
          (vendor: any) => vendor.id === getLiveAgentById?.vendor?.id
        )[0]?.value,
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useQuery(GET_ALL_VENDORS, {
    variables: {
      getAllvendorInputs: {
        page: 1,
        perPage: 10,
        searchText: '',
      },
    },
    onCompleted: (data) => {
      setVendors(
        data.getAllVendors?.vendorList?.map((vendor: any) => {
          return {
            id: vendor.id,
            value: `${vendor.vendorFirstName} ${vendor.vendorLastName}`,
          }
        })
      )
    },
  })
  //handlingfns
  const handleEdit = (id: string) => {
    getLiveagentbyId({
      variables: {
        getLiveAgentByIdId: id,
      },
    })
    setModalConfig({
      mode: 'EDIT',
      show: true,
    })
  }
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: handleEdit,
    },
  ]
  return (
    <>
      <Breadcrumbs title='Live Agents List' subTitle='Home - Live Agents List' />
      <SearchList
        idFieldName='id'
        filterOptions={filterOptions}
        setFilterOptions={setFilterOptions}
        listCount={liveagents?.getAllLiveAgents?.totalCount}
        paginatedCount={liveagents?.getAllLiveAgents?.liveAgents.length}
        listLoading={listLoading}
        toolbar={
          <>
            <button
              className='btn btn-primary fs-6 px-5 py-3 ms-5'
              onClick={() => {
                formik.setValues(defaultLiveAgentProps)
                setModalConfig({
                  mode: 'CREATE',
                  show: true,
                })
              }}
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Add Live Agent</span>
            </button>
          </>
        }
        apiData={liveagents?.getAllLiveAgents?.liveAgents}
        listConfigs={LISTCONFIGS}
        dropdownMenuItems={dropdownMenuItems}
        isActiveApiFieldName=''
      />

      <SharedModal
        show={modalConfig.show}
        className='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-650px'
        headerName={
          modalConfig.mode === 'CREATE' ? LATEXTS.addModalHeader : LATEXTS.editModalHeader
        }
        headerContent={
          <div className='form-check form-switch form-check-custom form-check-solid me-2'>
            <span className='badge-light-danger px-2 py-1 fs-7 fw-bold rounded-2'>Inactive</span>
            <input
              className='form-check-input mx-2 h-20px w-40px'
              style={{backgroundColor: '#808080'}}
              type='checkbox'
              value=''
              id='flexsSwitchDefault'
              checked={activeStatus}
              defaultChecked={true}
              onChange={(e) => setActiveStatus(e.target.checked)}
            />
            <label className='form-check-label ms-0' htmlFor='flexSwitchDefault'>
              <span className='badge-light-success fs-7 fw-bold rounded-2 px-2 py-1 '>Active</span>
            </label>
          </div>
        }
        handleClose={handleModalClose}
        handleSubmit={() => formik.submitForm()}
      >
        {getLoading ? (
          <div className='text-center h-300px'>
            <Spinner animation='border' className='text-gray-600' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className='p-5'>
            <TextField
              fieldName='liveagentFirstName'
              formik={formik}
              fieldTitle='First Name'
              filedTitleMandatory={true}
            />
            <TextField
              fieldName='liveagentLastName'
              formik={formik}
              fieldTitle='Last Name'
              filedTitleMandatory={false}
            />
            <TextField
              fieldName='liveagentEmail'
              formik={formik}
              fieldTitle='Email ID'
              filedTitleMandatory={true}
              disabled={modalConfig.mode === 'EDIT'}
            />
            <label className='d-flex align-items-center mb-2 required'>
              <span className='fs-6 fw-semibold lh-23px'>Vendor</span>
            </label>
            <Dropdown
              fieldName='liveagentVendor'
              optionList={vendors}
              handleSelectedItem={(value: any) => {
                formik.setFieldValue('liveagentVendor', value.label)
              }}
              formik={formik}
              fieldDisabled={modalConfig.mode === 'EDIT'}
              data={formik.values.liveagentVendor}
            />
          </div>
        )}
      </SharedModal>
    </>
  )
}
export default LiveAgents
